import React from 'react';
import { Box, Paper, Skeleton, Avatar } from '@mui/material';

const LoadingCandidateCard = () => {
  return (
    <Paper
      sx={{
        padding: '24px 16px',
        borderRadius: '12px',
        border: '1px solid #DCDFEA',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      {/* Candidate Header */}
      <Box
        sx={{
          display: 'flex',
          gap: '4px',
          alignItems: 'flex-start',
        }}
      >
        {/* Candidate Info */}
        <Box
          sx={{
            display: 'flex',
            gap: '16px',
            flex: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: '16px',
              alignItems: 'flex-start',
            }}
          >
            {/* Avatar Skeleton */}
            <Skeleton variant="circular" width={66} height={66} />
            
            {/* Basic Info Skeleton */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                width: '440px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                }}
              >
                {/* Name Skeleton */}
                <Skeleton variant="text" width={200} height={24} />
                
                {/* Current Job Skeleton */}
                <Skeleton variant="text" width={300} height={20} />
                
                {/* Location Skeleton */}
                <Skeleton variant="text" width={180} height={20} />
              </Box>
            </Box>
          </Box>
        </Box>
        
        {/* Action Buttons Skeleton */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}
        >
          <Skeleton variant="rectangular" width={32} height={32} sx={{ borderRadius: '8px' }} />
          <Skeleton variant="rectangular" width={32} height={32} sx={{ borderRadius: '8px' }} />
        </Box>
      </Box>
      
      {/* Matching Criteria Chips Skeleton */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          flexWrap: 'wrap',
        }}
      >
        {[...Array(3)].map((_, index) => (
          <Skeleton 
            key={index}
            variant="rectangular" 
            width={80 + (index * 20)} 
            height={24} 
            sx={{ borderRadius: '16px' }} 
          />
        ))}
      </Box>
      
      {/* AI Summary Skeleton */}
      <Paper
        sx={{
          padding: '12px',
          borderRadius: '8px',
          backgroundColor: '#FFFFFF',
          border: '1px solid rgba(234, 236, 240, 1)',
          display: 'flex',
          alignSelf: 'stretch',
          alignItems: 'flex-start',
          gap: '6px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '6px', flex: 1 }}>
          {/* AI Icon Skeleton */}
          <Skeleton variant="rectangular" width={16} height={16} />
          
          {/* AI Summary Text Skeleton */}
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="100%" height={20} />
            <Skeleton variant="text" width="80%" height={20} />
          </Box>
        </Box>
      </Paper>
    </Paper>
  );
};

export default LoadingCandidateCard;
